import React from "react";
import {
  colors,
  colors2,
  formatCamelCaseToSentenceCase,
  getVal,
  makeArrayFromLength,
  MetaBlockV2,
  SkeletonLoader,
  UI_BODY_BOLD_SM_DF,
  UI_BODY_DF,
  UI_TITLE,
  Wrapper700,
} from "oolib";

import { DataPivotResponsesList } from "./DataPivotResponsesList";
import { DataPivotVisualization } from "./DataPivotVisualization";
import { _Locale } from "@/components/locale/Locale";
import { useDynamicLayoutHeight } from "../../InsightMatrix/utils/useDynamicLayoutHeight";

export const DataPivotMainContent = ({
  data,
  dataFetchStatus,
  dataFetchError,
  activeBlock,
  subActiveBlock,
  contentType,
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,

  filterConfig,
  activeFilters,
  setActiveFilters,
}) => {
  if (!activeBlock) {
    return (
      <div style={{ padding: "2rem", textAlign: "center", color: colors2.grey60 }}>
        Select a field from the sidebar to view responses
      </div>
    );
  }

  const getAppropriateBlockLabel = (bl) =>
    bl.props?.shortLabel ||
    bl.props?.label ||
    formatCamelCaseToSentenceCase(bl.valuePath.replace("main.", ""));

    const {parentWrapperRef, gridHeightCSS} = useDynamicLayoutHeight({ observeLayoutChanges: true })
    
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", backgroundColor: colors.greyColor3 }}>
      <div style={{ padding: "1rem 1.4rem", background: colors.greyColor3 }}>
        <UI_TITLE>{getAppropriateBlockLabel(activeBlock)}</UI_TITLE>
      </div>

      <div style={{ flex: 1, overflow: "auto", display: "grid", gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)" }}>
        <div
          style={{
            backgroundColor: colors2.white,
            borderRadius: "8px",
            border: `1px solid ${colors2.grey10}`,
            marginLeft: "1.4rem",
            boxShadow: `0px 4px 4px rgba(0, 0, 0, 0.06)`,
          }}
        >
          <div style={{ padding: "0 1.4rem" }}>
            <div
              style={{
                padding: "1.2rem 0.8rem",
                borderBottom: `1px solid ${colors2.grey10}`,
              }}
            >
              <UI_BODY_BOLD_SM_DF>{`${_Locale("All Responses")} ${
                data?.pages[0]?.count ? `(${data?.pages[0]?.count})` : ""
              }`}</UI_BODY_BOLD_SM_DF>
            </div>
          </div>

          <DataPivotResponsesList
            data={data}
            dataFetchStatus={dataFetchStatus}
            dataFetchError={dataFetchError}
            activeBlock={activeBlock}
            hasNextPage={hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
            fetchNextPage={fetchNextPage}
          />
        </div>

        <div ref={parentWrapperRef} style={{ padding: "1.4rem", paddingTop: 0, position: "sticky", top: 0, alignSelf: "start", height: gridHeightCSS, overflow: "auto" }}>
            <DataPivotVisualization
              activeBlock={activeBlock}
              subActiveBlock={subActiveBlock}
              contentType={contentType}

              setActiveFilters={setActiveFilters}
              activeFilters={activeFilters}
              filterConfig={filterConfig}
          />
        </div>
      </div>
    </div>
  );
}; 
